import { createRequestConstantNames } from 'store/util/createConstants';
import cc from 'store/util/createReduxConstant';

export const [
  QUERY_IQS_FOR_IGNORED,
  QUERY_IQS_FOR_IGNORED_SUCCESS,
  QUERY_IQS_FOR_IGNORED_FAIL,
] = createRequestConstantNames(cc('QUERY_IQS_FOR_IGNORED'));
